import type { PollType } from '../types';
import { PollStatus } from '../types';

const availableStatuses = [PollStatus.OPEN, PollStatus.CLOSED, PollStatus.RESULTS_AVAILABLE];

const countdownStatuses = [PollStatus.UPCOMING, PollStatus.SCHEDULED];

const openStatuses = [PollStatus.OPEN];

const winnerStatuses = [PollStatus.RESULTS_AVAILABLE];

const closedStatuses = [PollStatus.CLOSED];

export const isValidPollStatus = (status: string): status is PollStatus =>
  (Object.values(PollStatus) as readonly string[]).includes(status);

export const getPollStatuses = (poll: PollType | null, status?: string) => {
  const pollStatus = status && isValidPollStatus(status) ? status : poll?.status;
  return {
    pollIsWinner: winnerStatuses.includes(pollStatus ?? ''),
    pollIsClosed: closedStatuses.includes(pollStatus ?? ''),
    pollIsOpen: openStatuses.includes(pollStatus ?? ''),
    pollIsScheduled: countdownStatuses.includes(pollStatus ?? ''),
    pollIsAvailable: availableStatuses.includes(pollStatus ?? ''),
  };
};
